import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../services/api';
import Header from '../components/Header';

export default function LoginPage() {
  const [params] = useSearchParams();
  const initialRole = params.get('role') === 'admin' ? 'admin' : 'dj';
  const [role, setRole] = useState(initialRole);

  // DJ
  const [djCode, setDjCode] = useState('');
  // Admin
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const formatDjCode = (val) => {
    const hex = val.toUpperCase().replace(/[^0-9A-F]/g, '').slice(0, 12);
    const parts = [hex.slice(0,4), hex.slice(4,8), hex.slice(8,12)].filter(Boolean);
    return parts.join('-');
  };

  const handleDjLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await api.djLogin(djCode);
      api.saveSession(res.token, res.role, res.roomCode, res.roomName);
      navigate('/dj');
    } catch (err) {
      setError(err.message || 'Неверный DJ-код');
    } finally { setLoading(false); }
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await api.adminLogin(username, password);
      api.saveSession(res.token, res.role, null, null);
      navigate('/admin');
    } catch (err) {
      setError('Неверный логин или пароль');
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell">
      <Header />
      <main className="entry-screen">
        <div className="entry-hero">
          <img src="/muzon/logo.png" alt="Muzon" className="entry-hero-logo" />
          <h1>{role === 'admin' ? 'Администратор' : 'Портал DJ'}</h1>
          <p>{role === 'admin'
            ? 'Создавайте и управляйте комнатами для мероприятий.'
            : 'Введите ваш персональный DJ-код, выданный администратором.'}</p>
        </div>

        <div className="entry-card">
          <div className="role-switch">
            <button className={`role-tab ${role==='dj'?'active':''}`} onClick={() => { setRole('dj'); setError(''); }}>🎧 DJ</button>
            <button className={`role-tab ${role==='admin'?'active':''}`} onClick={() => { setRole('admin'); setError(''); }}>⚙ Админ</button>
          </div>

          {role === 'dj' ? (
            <form className="entry-form" onSubmit={handleDjLogin}>
              <div className="input-group">
                <label className="input-label">DJ-код</label>
                <input
                  className="input input-code"
                  type="text"
                  placeholder="A1B2-C3D4-E5F6"
                  value={djCode}
                  onChange={e => setDjCode(formatDjCode(e.target.value))}
                  maxLength={14}
                  autoFocus
                  autoComplete="off"
                  spellCheck={false}
                  style={{ fontSize: 20, letterSpacing: '0.1em' }}
                />
              </div>
              {error && <div className="alert alert-error">{error}</div>}
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? <span className="spinner" /> : null}
                {loading ? 'Входим...' : 'Войти как DJ'}
              </button>
            </form>
          ) : (
            <form className="entry-form" onSubmit={handleAdminLogin}>
              <div className="input-group">
                <label className="input-label">Логин</label>
                <input className="input" type="text" placeholder="admin"
                  value={username} onChange={e => setUsername(e.target.value)} autoFocus />
              </div>
              <div className="input-group">
                <label className="input-label">Пароль</label>
                <input className="input" type="password" placeholder="••••••••"
                  value={password} onChange={e => setPassword(e.target.value)} />
              </div>
              {error && <div className="alert alert-error">{error}</div>}
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? <span className="spinner" /> : null}
                {loading ? 'Входим...' : 'Войти как админ'}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
